'use client';

import { c as _c } from "react/compiler-runtime";
import { Utensils, Users, Lightbulb } from 'lucide-react';
export function CredibilitySection() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-3 text-gray-600"><Utensils className="h-5 w-5 text-primary-600" /><span className="text-sm font-medium">Built for FMCG / CPG brands</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-3 text-gray-600"><Users className="h-5 w-5 text-primary-600" /><span className="text-sm font-medium">{"Designed with retailers, venues & agencies"}</span></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="py-12 border-y border-gray-100 bg-gray-50/50"><div className="container mx-auto px-4 sm:px-6 lg:px-8"><div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 text-center">{t0}{t1}<div className="flex items-center gap-3 text-gray-600"><Lightbulb className="h-5 w-5 text-primary-600" /><span className="text-sm font-medium">By people who've run awareness + trial campaigns for consumers and buyers</span></div></div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}